import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GerenciaArquivo } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { StorageService } from 'src/app/services/storage/storage.service';
import { GerenciaArquivoService } from '../gerencia-arquivo.service';

@Component({
  selector: 'app-modal-atualiza-arquivo',
  templateUrl: './modal-atualiza-arquivo.component.html',
  styleUrls: ['./modal-atualiza-arquivo.component.scss']
})
export class ModalAtualizaArquivoComponent implements OnInit {
  files: any;
  usuario: any;
  public fileName: '';
  public gerenciaArquivo: GerenciaArquivo;


  constructor(private gerenciaArquivoService: GerenciaArquivoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAtualizaArquivoComponent>,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.usuario = StorageService.getPerfilUsuario();
  }


  onFileChange(ev): void {
    this.files = ev.target.files;
    this.fileName = this.files[0].name;
  }

  uploadImage(): void {
    if (this.files.length === 0) {
      return;
    }

    let fileToUpload = <File>this.files[0];
    const formData = new FormData();

    formData.append('file', fileToUpload, fileToUpload.name);

    this.gerenciaArquivoService.upLoadArquivo(formData).subscribe(obj => {

      obj.id = this.data.id;
      obj.usuario = this.usuario.username;


      this.gerenciaArquivoService.atualizaArquivo(obj).subscribe(obj => {
        this.openSnackBar("Arquivo atualizado com sucesso");
        this.dialogRef.close("");
      }, error => {
        console.log(error)
      })
    }, error => {
      console.log(error)
    })
  }

  openSnackBar(message: string): any {
    this.snackBar.open(message, null, { duration: 5000 });
  }
}
